module.exports = __webpack_public_path__ + "img/product3p.fdf66528.png";